import {
	OrderPartnerReviewRatingEnum,
	OrderStatus,
} from "Infrastructure/Api/Api";
import { z } from "zod";

export const getOrderFilterFormSchema = () => {
	return z.object({
		status: z.array(z.nativeEnum(OrderStatus)).nullish(),
		dateNextActionFrom: z.string().nullish(),
		dateNextActionTo: z.string().nullish(),
		dateStartingFrom: z.string().nullish(),
		dateStartingTo: z.string().nullish(),
		partnerId: z.number().nullish(),
		unassignedPartner: z.boolean().nullish(),
		regionId: z.number().nullish(),
		userId: z.number().nullish(),
		unassignedUser: z.boolean().nullish(),
		query: z.string().nullish(),
		review: z.nativeEnum(OrderPartnerReviewRatingEnum).nullish(),
		notReviewed: z.boolean().nullish(),
		hasExamination: z.boolean().nullish(),
		b2b: z.string().nullish(),
		promoCode: z.string().nullish(),
		followUpAgentStatus: z.array(z.string()).nullish(),
	});
};

export type OrderFilterFormModel = z.infer<
	ReturnType<typeof getOrderFilterFormSchema>
>;
